"use strict";

// angular.module('ccsTrApp').directive('languageSelector', function( Language ){
angular.module('ccsTrApp').directive('languageSelector', function(){
    return {
        restrict: "EA",
        replace: true,
        templateUrl: "app/layouts/language/language-selector.tpl.html",
        scope: true
    }
});
